import * as moment from 'moment';

import React, { Component } from 'react';
import { ReactSVG } from 'react-svg';
import { sprintf } from 'sprintf-js';

import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Modal from 'react-bootstrap/Modal';

import EditorJS from '@editorjs/editorjs';
import Header from '@editorjs/header';
import List from '@editorjs/list';
import Table from '@editorjs/table';
import Delimiter from '@editorjs/delimiter';
import Marker from '@editorjs/marker';
import Quote from '@editorjs/quote';
import Paragraph from '@editorjs/paragraph';
import Warning from '@editorjs/warning';
import Embed from '@editorjs/embed';
import ImageTool from '@editorjs/image';

import styles from './Content.module.css';

import headerImage from './../images/modules/content.jpg';

import addIcon from './../icons/ic_add_circle.svg';
import uploadIcon from './../icons/ic_upload.svg';
import deleteIcon from './../icons/ic_delete.svg';

import { CPLBanner } from '../../../components/Banner';
import Underline from '../../../components/editor/Underline';
import { LanguageContext } from '../../../i18n/LanguageContext';

import { ContentService } from '../../../services/ApiService';

export default class ContentModule extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            contents: [],
            content: null,
            search: '',
            showContentModal: false,
            contentTypeMap: {
                en: {
                    'news': 'News',
                    'announcement': 'Announcement',
                    'event': 'Event'
                },
                es: {
                    'news': 'Noticias',
                    'announcement': 'Anuncio',
                    'event': 'Evento'
                }
            }
        }
    }

    onSearch = (search) => {
        this.setState({ search });
    }

    onRowClicked = (content) => {
        this.setState({ showEditor: false });
        setTimeout(() => {
            this.setState({ mode: 'update', showEditor: true, content: content });
        }, 0);
    }

    onCreate = () => {
        this.setState({ showEditor: false });
        setTimeout(() => {
            this.setState({ mode: 'create', showEditor: true, content: null });
        }, 0);
    }

    onCancel = () => {
        this.setState({ showEditor: false, content: null });
    }

    onDelete = (content) => {
        this.setState({ content: content, showConfirmDeleteModal: true });
    }

    onSave = (data, mode) => {
        if (mode === 'create') {
            ContentService.create(data)
                .then(async (response) => {
                    if (response.type !== 'announcement') {
                        this.setState({ showEditor: false, content: null});
                        this.setState({ mode: 'update', content: response, showEditor: true, successCreateModalShow: true, successModalContent: response });
                        this.getData();
                    } else {
                        this.setState({ showEditor: false, content: null, successModalShow: true });
                        this.getData();
                    }
                })
                .catch(e => console.error(e));
        } else {
            ContentService.update(data)
                .then(() => {
                    this.setState({ showEditor: false, content: null, successModalShow: true });
                    this.getData();
                })
                .catch(e => console.error(e));
        }
    }

    onOpenContentModal = (content) => {
        this.setState({ showContentModal: true, content: content });
    }

    onContentModalClose = () => {
        this.setState({ showContentModal: false });
    }

    onEditorDataSave = (data, lang) => {
        const content = { ...this.state.content };
        content.content[lang] = data;

        ContentService.update(content)
            .then(() => {
                this.setState({ content: content });
            })
            .catch(e => console.error(e));

    }

    getData = () => {
        ContentService.getAll()
            .then(contents => {
                this.setState({ contents })
            })
            .catch(e => console.error(e));
    }

    componentDidMount() {
        this.getData();
    }

    onSuccessContentModalNext = (content) => {
        this.setState({ showContentModal: true, content: content, successCreateModalShow: false });
    }

    onClickSave = () => {
        this.setState({ successModalShow: true });
        this.getData();
    }

    onDeleteConfirmModal = (id) => {
        ContentService.delete(id)
            .then(() => {
                this.setState({ showEditor: false, content: null, showConfirmDeleteModal: false });
                this.getData();
            })
            .catch(e => console.error(e));
    }

    render() {
        let contents = this.state.contents.map(content => {
            content.titleValue = content.title[this.context['LANG']];
            if (!!content.content) {
                content.contentValue = content.content[this.context['LANG']];
            }

            content.abstractValue = content.abstract[this.context['LANG']];
            content.typeValue = this.state.contentTypeMap[this.context['LANG']][content.type];
            return content;
        });

        if (!!this.state.search) {
            contents = contents
                .filter(content => this.filterContents(this.state.search, content, [
                    'titleValue',
                    'abstractValue',
                    'typeValue',
                ]));
        }

        return <div className="col-md-12">
            <div className="row banner-wrapper">
                <div className="col-md-12">
                    <CPLBanner
                        img={headerImage}
                        content={this.context['CONTENT_ADMIN_MODULE_NAME']} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-7 col-md-7">
                    <ContentAdmin
                        contents={contents}
                        onRowClicked={this.onRowClicked}
                        onCreate={this.onCreate}
                        onSearch={this.onSearch} />
                </div>
                <div className="col-lg-5 col-md-5">
                    {!!this.state.showEditor ? <Editor
                        content={this.state.content || {}}
                        onDelete={this.onDelete}
                        onSave={this.onSave}
                        mode={this.state.mode}
                        onContentClicked={this.onOpenContentModal}
                        onCancel={this.onCancel} /> : null}
                </div>
            </div>

            <ConfirmDeleteModal
                content={this.state.content}
                onClose={() => { this.setState({ showConfirmDeleteModal: false }) }}
                context={this.context}
                onDelete={this.onDeleteConfirmModal}
                show={this.state.showConfirmDeleteModal} />

            {!!this.state.showContentModal ? <ContentModal
                content={this.state.content}
                save={this.onEditorDataSave}
                onClickSave={this.onClickSave}
                show={this.state.showContentModal}
                onHide={this.onContentModalClose} /> : null}

            <SuccessSaveModal
                show={this.state.successModalShow}
                onHide={() => { this.setState({ successModalShow: false }) }} />

            {!!this.state.successCreateModalShow ? <SuccessCreateModal
                show={this.state.successCreateModalShow}
                content={this.state.successModalContent}
                next={this.onSuccessContentModalNext}
                onHide={() => { this.setState({ successCreateModalShow: false }) }} /> : null}

        </div>
    }

    filterContents(search, content, properties) {
        for (let prop of properties) {
            if (RegExp(`(.)*${search}(.)*`, 'i').test(content[prop])) {
                return true;
            }
        }
        return false;
    }
}

class ContentAdmin extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            search: ''
        };
    }

    onSearchListener = (evt) => {
        this.props.onSearch(evt.target.value);
        this.setState({ search: evt.target.value });
    }

    render() {
        return <div>
            <div className="card">
                <div className="card-header">
                    {this.context['CONTENTS']}
                    <span className="float-right">
                        <OverlayTrigger
                            key="top"
                            placement="top"
                            overlay={<Tooltip>{this.context['ADD']}</Tooltip>}>
                            <div className={styles['panel-button']} onClick={this.props.onCreate}>
                                <ReactSVG
                                    src={addIcon}
                                    className={styles['add-button']} />
                            </div>
                        </OverlayTrigger>
                    </span>
                    <span className="float-right">
                        <div className={styles['search-form']}>
                            <input type="text" value={this.state.search} onChange={this.onSearchListener} placeholder={`${this.context['SEARCH']}...`} />
                        </div>
                    </span>
                </div>
                <div className="card-body">
                    <table className="table table-borderless table-hover">
                        <thead>
                            <tr>
                                <th>{this.context['TITLE']}</th>
                                <th>{this.context['ABSTRACT']}</th>
                                <th>{this.context['TYPE']}</th>
                            </tr>
                        </thead>
                        <ListItems
                            lang={this.context}
                            onRowClicked={this.props.onRowClicked}
                            contents={this.props.contents} />
                    </table>
                </div>
            </div>
        </div>
    }
}

const ListItems = (props) => {
    return <tbody>
        {props.contents.map((content, index) => {
            return <ListItem
                key={index}
                index={index}
                content={content}
                onRowClicked={props.onRowClicked}
                lang={props.lang} />
        })}
    </tbody>
}

const ListItem = (props) => {
    const content = props.content;

    return <tr className={styles['editor-row-clickable']} onClick={() => props.onRowClicked(content)}>
        <td>{content.titleValue}</td>
        <td>{content.abstractValue}</td>
        <td>{content.typeValue}</td>
    </tr>
}

class Editor extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);

        const content = this.props.content;
        if (this.props.mode === 'update') {
            content.startDate = moment.utc(content.startDate).format('YYYY-MM-DD');
            content.expirationDate = moment.utc(content.expirationDate).format('YYYY-MM-DD');
        } else {
            content.startDate = moment().add(1, 'd').format('YYYY-MM-DD');
            content.expirationDate = moment().add(1, 'M').format('YYYY-MM-DD');
        }

        this.state = {
            mode: this.props.mode,
            content: {
                ...{
                    title: {
                        en: '',
                        es: ''
                    },
                    abstract: {
                        en: '',
                        es: ''
                    },
                    content: {
                        en: {},
                        es: {}
                    },
                    type: '',
                    startDate: moment().add(1, 'd').format('YYYY-MM-DD'),
                    expirationDate: moment().add(1, 'M').format('YYYY-MM-DD')
                },
                ...content
            },
            missingArgumentsClass: {
                titleSpanish: styles['editor-form-control'],
                abstractSpanish: styles['editor-form-control'],
                titleEnglish: styles['editor-form-control'],
                abstractEnglish: styles['editor-form-control'],
                type: 'form-control',
                startDate: styles['editor-form-control'],
                expirationDate: styles['editor-form-control'],
                cover: styles['content-file'],
                thumbail: styles['content-file']
            }
        };
    }

    onContentClicked = () => {
        this.props.onContentClicked(this.state.content);
    }

    onCoverImageUpload = (evt) => {
        const file = evt.target.files[0];
        const fileName = file.name;
        const ext = fileName.substr(fileName.lastIndexOf('.') + 1);
        if (ext !== 'png' && ext !== 'jpg' && ext !== 'jpeg') {
            alert(this.context['CONTENT_INVALID_IMAGE_TYPE']);
            return;
        }

        this.setState({ coverImageFileName: fileName, coverImage: file });
    }

    onThumbnailImageUpload = (evt) => {
        const file = evt.target.files[0];
        const fileName = file.name;
        const ext = fileName.substr(fileName.lastIndexOf('.') + 1);
        if (ext !== 'png' && ext !== 'jpg' && ext !== 'jpeg') {
            alert(this.context['CONTENT_INVALID_IMAGE_TYPE']);
            return;
        }

        this.setState({ thumbnailImageFileName: fileName, thumbnailImage: file });
    }

    onDelete = () => {
        this.props.onDelete(this.state.content);
    }

    save() {
        const content = this.state.content;

        const missingArguments = [];

        if (!content.title.es) {
            missingArguments.push('titleSpanish');
        }
        if (!content.abstract.es) {
            missingArguments.push('abstractSpanish');
        }

        if (!content.title.en) {
            missingArguments.push('titleEnglish');
        }
        if (!content.abstract.en) {
            missingArguments.push('abstractEnglish');
        }

        if (!content.type) {
            missingArguments.push('type');
        }

        if (!content.startDate) {
            missingArguments.push('startDate');
        }
        if (!content.expirationDate) {
            missingArguments.push('expirationDate');
        }

        if (this.props.mode === 'create') {
            if (content.type === 'news' || content.type === 'event') {
                if (!this.state.coverImage) {
                    missingArguments.push('cover');
                }
                if (!this.state.thumbnailImage) {
                    missingArguments.push('thumbail');
                }
            }
        }

        if (!!missingArguments.length) {
            this.setState({
                missingArgumentsClass: this.getMissingArgumentMap(missingArguments)
            });
            return;
        }


        if (content.type === 'news' || content.type === 'event') {
            content.coverImage = this.state.coverImage;
            content.thumbnailImage = this.state.thumbnailImage;
        }

        this.props.onSave(content, this.state.mode)
    }

    getMissingArgumentMap(missingArguments) {
        let missingArgumentsMap = {}
        for (let argument of missingArguments) {
            if (argument === 'cover' || argument === 'thumbail') {
                missingArgumentsMap[argument] = styles['content-file-error'];
            } else if (argument === 'type') {
                missingArgumentsMap[argument] = `form-control ${styles['editor-form-control-error']}`;//'form-control' + ' ' + styles['editor-form-control-error'];
            } else {
                missingArgumentsMap[argument] = styles['editor-form-control-error'];
            }
        }

        return {
            ...{
                titleSpanish: styles['editor-form-control'],
                abstractSpanish: styles['editor-form-control'],
                titleEnglish: styles['editor-form-control'],
                abstractEnglish: styles['editor-form-control'],
                type: 'form-control',
                startDate: styles['editor-form-control'],
                expirationDate: styles['editor-form-control'],
                cover: styles['content-file'],
                thumbail: styles['content-file']
            },
            ...missingArgumentsMap
        }
    }

    render() {
        const dotStyle = {
            color: '#f00'
        }

        const labelClassName = `col-md-4`;
        const labelValueClassName = `col-md-8`;

        return <div className="card">
            <div className="card-header">
                {this.props.mode === 'create' ? this.context['CONTENTS_NEW'] : this.context['CONTENT_UPDATE']}
                {this.props.mode === 'update' ? <span className="float-right">
                    <div className={styles['item-icon']}>
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>{this.context['DELETE']}</Tooltip>}>
                            <ReactSVG src={deleteIcon} className={styles['delete-button']} onClick={this.onDelete} />
                        </OverlayTrigger>
                    </div>
                </span> : null}
            </div>
            <div className={`card-body ${styles['editor-rows']}`}>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className='col-md-12'>
                        <p className={styles['editor-form-control-label']}>{this.context['SPANISH']}</p>
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['TITLE']} <b style={dotStyle}>*</b></p>
                    </div>
                    <div className={labelValueClassName}>

                        <input className={this.state.missingArgumentsClass['titleSpanish']} value={this.state.content.title.es} type="text" onChange={(e) => {
                            const content = { ...this.state.content };
                            content.title.es = e.target.value;
                            this.setState({ content })
                        }
                        } />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['ABSTRACT']} <b style={dotStyle}>*</b></p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={this.state.missingArgumentsClass['abstractSpanish']} value={this.state.content.abstract.es} type="text" onChange={(e) => {
                            const content = { ...this.state.content };
                            content.abstract.es = e.target.value;
                            this.setState({ content })
                        }
                        } />
                    </div>
                </div>
                <div className={styles['divider']}></div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className='col-md-12'>
                        <p className={styles['editor-form-control-label']}>{this.context['ENGLISH']}</p>
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['TITLE']} <b style={dotStyle}>*</b></p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={this.state.missingArgumentsClass['titleEnglish']} value={this.state.content.title.en} type="text" onChange={(e) => {
                            const content = { ...this.state.content };
                            content.title.en = e.target.value;
                            this.setState({ content })
                        }
                        } />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['ABSTRACT']} <b style={dotStyle}>*</b></p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={this.state.missingArgumentsClass['abstractEnglish']} value={this.state.content.abstract.en} type="text" onChange={(e) => {
                            const content = { ...this.state.content };
                            content.abstract.en = e.target.value;
                            this.setState({ content })
                        }} />
                    </div>
                </div>
                <div className={styles['divider']}></div>
                {this.getTypeSelectComponent()}
                {this.getUploadComponent()}
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['START_DATE']} <b style={dotStyle}>*</b></p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={this.state.missingArgumentsClass['startDate']} value={this.state.content.startDate} type="date" onChange={(e) => {
                            if (!!e.target.value) {
                                if(moment(e.target.value).isBefore(this.state.content.expirationDate)) {
                                    const content = { ...this.state.content };
                                    content.startDate = e.target.value;
                                    this.setState({ content })
                                }
                            }
                        }} />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['EXPIRATION_DATE']} <b style={dotStyle}>*</b></p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={this.state.missingArgumentsClass['expirationDate']} value={this.state.content.expirationDate} type="date" onChange={(e) => {
                            if (!!e.target.value) {
                                if(moment(e.target.value).isAfter(this.state.content.startDate)) {
                                    const content = { ...this.state.content };
                                    content.expirationDate = e.target.value;
                                    this.setState({ content });
                                }
                            }
                        }} />
                    </div>
                </div>
            </div>
            <div className="card-footer">
                <span className="float-right">
                    <Button variant="success" onClick={() => this.save()}>
                        {this.context['SAVE']}
                    </Button>
                </span>
                {this.getEditorButton()}
                <span className="float-right">
                    <Button variant="danger" onClick={() => this.props.onCancel()}>
                        {this.context['CLOSE']}
                    </Button>
                </span>
            </div>
        </div>
    }

    getTypeSelectComponent() {
        if (this.props.mode === 'create') {
            const dotStyle = {
                color: '#f00'
            };

            return <span>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{this.context['TYPE']} <b style={dotStyle}>*</b></p>
                    </div>
                    <div className="col-md-8">
                        <select value={this.state.content.type} className={this.state.missingArgumentsClass['type']} onChange={(e) => {
                            const content = { ...this.state.content };
                            content.type = e.target.value;
                            this.setState({ content })
                        }} >
                            <option value=''>{this.context['SELECT']}</option>
                            <option value="news">{this.context['NEWS']}</option>
                            <option value="announcement">{this.context['ANNOUNCEMENT']}</option>
                            <option value="event">{this.context['EVENT']}</option>
                        </select>
                    </div>
                </div>
                <div className={styles['divider']}></div>
            </span>
        }

        return null;
    }

    getEditorButton() {
        if (this.props.mode === 'update') {
            if (this.state.content.type === 'news' || this.state.content.type === 'event') {
                return <span className="float-right">
                    <Button variant="primary" onClick={this.onContentClicked}>
                        {this.context['CONTENT']}
                    </Button>
                </span>
            }
        }

        return null;
    }

    getUploadComponent() {
        if (this.state.content.type === 'news' || this.state.content.type === 'event') {
            const dotStyle = {
                color: '#f00'
            };

            return <span>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-12">
                        <p className={styles['editor-form-control-label']}>{this.context['CONTENT_IMAGES_TITLE']}</p>
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{this.context['CONTENT_COVER_IMAGE']} {this.props.mode === 'create' ? <b style={dotStyle}>*</b> : null}</p>
                    </div>
                    <div className="col-md-8">
                        <div className={styles['file-input-container']}>
                            <input type="file" name="cover_image_file" id="cover_image_file" className={this.state.missingArgumentsClass['cover']} onChange={this.onCoverImageUpload} accept=".png,.jpg,.jpeg" />
                            <label htmlFor="cover_image_file">
                                <ReactSVG src={uploadIcon} className={styles['upload-button']} />
                                {!!this.state.coverImageFileName ? this.state.coverImageFileName : this.context['CONTENT_SELECT_FILE_DEFAULT']}
                                
                            </label>
                            <small>{this.context['DIMENSIONS']}: (1200px x 310px)</small>
                        </div>
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-fosrm-control-label']}>{this.context['CONTENT_THUMBNAIL_IMAGE']} {this.props.mode === 'create' ? <b style={dotStyle}>*</b> : null}</p>
                    </div>
                    <div className="col-md-8">
                        <div className={styles['file-input-container']}>
                            <input type="file" name="thumbnail_image_file" id="thumbnail_image_file" className={this.state.missingArgumentsClass['thumbail']} onChange={this.onThumbnailImageUpload} accept=".png,.jpg,.jpeg" />
                            <label htmlFor="thumbnail_image_file">
                                <ReactSVG src={uploadIcon} className={styles['upload-button']} />
                                {!!this.state.thumbnailImageFileName ? this.state.thumbnailImageFileName : this.context['CONTENT_SELECT_FILE_DEFAULT']}
                            </label>
                            <small>{this.context['DIMENSIONS']}: (200px x 165px)</small>
                        </div>
                    </div>
                </div>
                <div className={styles['divider']}></div>
            </span>
        }

        return null;
    }
}

class ContentModal extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);

        this.state = {
            show: props.show,
            content: props.content,
            editor: null,
            saveInterval: null,
            lang: this.context['LANG'],
            data: {},
            previousVersion: 0,
            currentVersion: 0
        }
    }

    onEditorChange = () => {
        const currentVersion = this.state.currentVersion + 1;
        this.setState({ currentVersion: currentVersion });
    }

    onHide = () => {
        this.onSave();
        setTimeout(() => this.cleanUp(), 1000);
    }

    cleanUp = () => {
        if (!!this.state.saveInterval) {
            clearInterval(this.state.saveInterval);
        }
        this.props.onHide();
    }

    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    onSave = (closeOnSave = false) => {
        if (!!this.props.show && !!this.state.editor) {
            const lang = this.state.lang;
            try {
                const currentVersion = this.state.currentVersion;
                const previousVersion = this.state.previousVersion;

                if (previousVersion !== currentVersion) {
                    this.state.editor.save()
                        .then(data => {
                            console.log(`DATA`);
                            console.log(data);
                            this.setState({
                                previousVersion: currentVersion
                            });

                            this.props.save(data, lang);
                            if (!!closeOnSave) {
                                this.onHide();
                            }
                        })
                        .catch(err => console.error(err));
                }
            } catch (e) {
                this.onSave();
            }
        }
    }

    onClickSave = () => {
        this.onSave();
        setTimeout(() => {
            this.cleanUp()
            this.props.onClickSave();
        }, 1000);
    }

    onLanguageChange = (evt) => {
        const lang = evt.target.value;
        this.state.editor.destroy();

        const id = this.state.content.id;

        this.setState({
            lang: lang,
            previousVersion: 0,
            currentVersion: 0,
            editor: new EditorJS({
                holder: 'content-editor',
                autofocus: true,
                tools: {
                    header: {
                        class: Header,
                        inlineToolbar: ['link']
                    },
                    list: {
                        class: List,
                        inlineToolbar: true
                    },
                    table: {
                        class: Table,
                        inlineToolbar: true,
                        config: {
                            rows: 2,
                            cols: 2
                        },
                    },
                    Marker: {
                        class: Marker
                    },
                    Underline: {
                        class: Underline
                    },
                    paragraph: {
                        class: Paragraph,
                        inlineToolbar: true,
                    },
                    delimiter: Delimiter,
                    quote: Quote,
                    warning: Warning,
                    embed: {
                        class: Embed,
                        config: {
                            services: {
                                youtube: true,
                                coub: true
                            }
                        }
                    },
                    image: {
                        class: ImageTool,
                        config: {
                            uploader: {
                                uploadByFile(file) {
                                    return ContentService.uploadImage(id, file).then(response => response);
                                }
                            }
                        }
                    }
                },
                onChange: () => this.onEditorChange(),
                data: this.state.content.content[lang]
            })
        });
    }

    componentDidMount() {
        if (!this.props.show) {
            return;
        }

        const saveInterval = setInterval(() => {
            this.onSave()
        }, 10000);

        const id = this.state.content.id;

        this.setState({
            saveInterval,
            editor: new EditorJS({
                holder: 'content-editor',
                autofocus: true,
                tools: {
                    header: {
                        class: Header,
                        inlineToolbar: ['link']
                    },
                    list: {
                        class: List,
                        inlineToolbar: true
                    },
                    table: {
                        class: Table,
                        inlineToolbar: true,
                        config: {
                            rows: 2,
                            cols: 2
                        },
                    },
                    Marker: {
                        class: Marker
                    },
                    Underline: {
                        class: Underline
                    },
                    paragraph: {
                        class: Paragraph,
                        inlineToolbar: true,
                    },
                    delimiter: Delimiter,
                    quote: Quote,
                    warning: Warning,
                    embed: {
                        class: Embed,
                        config: {
                            services: {
                                youtube: true,
                                coub: true
                            }
                        }
                    },
                    image: {
                        class: ImageTool,
                        config: {
                            uploader: {
                                uploadByFile(file) {
                                    return ContentService.uploadImage(id, file).then(response => response);
                                }
                            }
                        }
                    }
                },
                onChange: () => {
                    this.onEditorChange()
                },
                data: this.state.content.content[this.state.lang]
            })
        });
    }

    render() {
        const content = { ...this.state.content };
        if (!this.props.show) {
            return '';
        }

        const spanishIcon = '🇵🇦';
        const englishIcon = '🇺🇸';

        return <Modal show={this.props.show} onHide={this.onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="row">
                        <div className="col-md-6">
                            <b>{content.title[this.context['LANG']]}</b>
                        </div>
                        <div className="col-md-6">
                            <span className="float-right-full">
                                <div className={styles['content-modal-language-holder']}>
                                    <select
                                        className={styles['modal-lang']}
                                        value={this.state.lang}
                                        onChange={this.onLanguageChange} >
                                        <option value='es'>{spanishIcon}</option>
                                        <option value="en">{englishIcon}</option>
                                    </select>
                                    <p className={styles['content-modal-language']}>{this.context['CONTENT_MODAL_LANGUAGE']}</p>
                                </div>
                            </span>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div id="content-editor">

                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={() => this.onClickSave()}>
                    {this.context['SAVE']}
                </Button>
            </Modal.Footer>
        </Modal>
    }
}

class SuccessSaveModal extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            show: props.show
        }
    }

    onHide = () => {
        this.props.onHide();
    }

    render() {
        return <Modal show={this.props.show} onHide={this.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{this.context['CONTENT_SAVED_SUCCESSFULLY_TITLE']}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{this.context['CONTENT_SAVED_SUCCESSFULLY_BODY']}</Modal.Body>
        </Modal>
    }
}

class SuccessCreateModal extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            content: props.content,
            show: props.show,
            next: props.next
        }
    }

    onHide = () => {
        this.props.onHide();
    }

    createMarkup = (content) => {
        return {
            __html: content
        };
    }

    onNext = () => {
        this.props.next(this.state.content);
    }

    render() {
        let title;
        let articleInRender = 'The';
        switch (this.state.content.type) {
            case 'news':
                title = this.context['NEWS'];
                break;
            case 'event':
                title = this.context['EVENT'];
                break;
            default:
                title = '';
                break;
        }

        if(this.context['LANG'] === 'es') {
            switch (this.state.content.type) {
                case 'news':
                    articleInRender = 'la';
                    break;
                case 'event':
                    articleInRender = 'el';
                    break;
                default:
                    title = 'el';
                    break;
            }
        }

        return <Modal show={this.props.show} onHide={this.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body><div dangerouslySetInnerHTML={this.createMarkup(sprintf(this.context['CREATE_CONTENT_SUCCESS_MODAL_ADD_DATA'], articleInRender, title))} /></Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={() => this.onNext()}>
                    {this.context['NEXT']}
                </Button>
            </Modal.Footer>
        </Modal>
    }
}

const ConfirmDeleteModal = (props) => {
    if (!props.show) {
        return '';
    }

    const createMarkup = (content) => {
        return {
            __html: content
        };
    }

    const content = props.content;
    const context = props.context;

    const title = content.title[context['LANG']];


    return <Modal show={props.show} onHide={props.onClose}>
        <Modal.Header closeButton>
            <Modal.Title>{context['CONTENT_DELETE_CONFIRM_TITLE']}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div dangerouslySetInnerHTML={createMarkup(sprintf(context['CONTENT_DELETE_CONFIRM_BODY'], title))} />
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={props.onClose}>
                {context['CLOSE']}
            </Button>
            <Button variant="danger" onClick={() => props.onDelete(content.id)}>
                {context['DELETE']}
            </Button>
        </Modal.Footer>
    </Modal>
}